import Autocomplete from "./library/Autocomplete";
import {TRAFFIC_TYPES_ARRAY} from "../utils/misc";
import { isAllowedFilterField } from "../utils/UserHelper";

function TrafficTypeAutocomplete(props: any) {
  return (
    <Autocomplete
      id="trafficTypeAutocomplete1"
      placeholder="Traffic Type"
      reactKey="trafficTypeAutocomplete2" 
      labelKey="name"
      onChange={props.onChange}
      options={TRAFFIC_TYPES_ARRAY}
      selected={props.selected}
      reactRef={props.reactRef}
      disabled={props.disabled}
      useIncludeExclude={isAllowedFilterField("trafficTypesExclude")}
      defaultIncludeExclude={props.defaultIncludeExclude}
      includeExcludeOnChange={props.includeExcludeOnChange}
      multiple
    />
  );
}

export default TrafficTypeAutocomplete;
